export default function isComponent(data) {
    return typeof data === 'object' && data !== null && 'type' in data && 'name' in data && 'typeId' in data;
}
